import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const userWrapper = () => css`
  width: 10rem;
`;

export const dateWrapper = () => css`
  width: 7rem;
`;

export const description = () => css`
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const notesPopoverWrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 25rem;
  padding: ${theme.remSize[150]};
  gap: ${theme.remSize[100]};
  display: flex;
  flex-direction: column;
`;
